import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fare-info" }
const _hoisted_2 = {
  key: 0,
  class: "fare-info-list"
}
const _hoisted_3 = { class: "fare-info-list__item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Компания: ")
const _hoisted_5 = { class: "fare-info-list__item" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Класс: ")
const _hoisted_7 = { class: "fare-info-list__item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Код тарифа: ")
const _hoisted_9 = { class: "fare-info-list__item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Семейство тарифа: ")
const _hoisted_11 = {
  key: 1,
  class: "fare-info-list"
}
const _hoisted_12 = { class: "fare-info-list__item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Компания: ")
const _hoisted_14 = { class: "fare-info-list__item" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Класс: ")
const _hoisted_16 = { class: "fare-info-list__item" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Код тарифа: ")
const _hoisted_18 = { class: "fare-info-list__item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Семейство тарифа: ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isSelected)
      ? (_openBlock(), _createBlock("ul", _hoisted_2, [
          _createVNode("li", _hoisted_3, [
            _hoisted_4,
            _createVNode("b", null, _toDisplayString((_ctx.item.itineraries[0].airline && _ctx.item.itineraries[0].airline.name) ? _ctx.item.itineraries[0].airline.name : "Н/Д"), 1)
          ]),
          _createVNode("li", _hoisted_5, [
            _hoisted_6,
            _createVNode("b", null, _toDisplayString(_ctx.item.itineraries[0].fare.fareName), 1)
          ]),
          _createVNode("li", _hoisted_7, [
            _hoisted_8,
            _createVNode("b", null, _toDisplayString(_ctx.item.itineraries[0].legs[0].flights[0].fareName), 1)
          ]),
          _createVNode("li", _hoisted_9, [
            _hoisted_10,
            _createVNode("b", null, _toDisplayString(_ctx.item.itineraries[0].familyCode), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSelected)
      ? (_openBlock(), _createBlock("ul", _hoisted_11, [
          _createVNode("li", _hoisted_12, [
            _hoisted_13,
            _createVNode("b", null, _toDisplayString((_ctx.selectedItem.itineraries[0].airline && _ctx.selectedItem.itineraries[0].airline.name) ? _ctx.selectedItem.itineraries[0].airline.name : "Н/Д"), 1)
          ]),
          _createVNode("li", _hoisted_14, [
            _hoisted_15,
            _createVNode("b", null, _toDisplayString(_ctx.selectedItem.itineraries[0].fareFamily.name), 1)
          ]),
          _createVNode("li", _hoisted_16, [
            _hoisted_17,
            _createVNode("b", null, _toDisplayString(_ctx.selectedItem.itineraries[0].legs[0].flights[0].fareName), 1)
          ]),
          _createVNode("li", _hoisted_18, [
            _hoisted_19,
            _createVNode("b", null, _toDisplayString(_ctx.selectedItem.itineraries[0].familyCode), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}